export default "__VITE_ASSET__r93rrftk__"